import React from 'react';
import Error from '../mdc/wrappers/error/error';

const withErrorBoundary = WrappedComponent => class extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
      info: null,
    };
  }

  componentDidCatch(error, info) {
    this.setState({ error, info });
  }

  render() {
    const { error, info } = this.state;

    if (error) {
      return (
        <Error title={String(error)}>
          <code>
            <pre>{info.componentStack.trim()}</pre>
          </code>
        </Error>
      );
    }

    return <WrappedComponent {...this.props} />;
  }
};

export default withErrorBoundary;
